import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type {
	Bundle,
	BundleMetaData,
	MixedItemDistResponse,
} from "@memorang/types";
import axios from "axios";
import type { MixedItemDistributionRequest } from "./types";

export async function getMixedItemDistribution(
	request: MixedItemDistributionRequest,
): Promise<MixedItemDistResponse> {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/user-events/mixed-item-distribution`,
		request,
		{
			headers: {
				"Content-Type": "application/json",
			},
		},
	);

	return data.data;
}

export async function fetchProductDetails({
	tenantId,
	productId,
}: {
	tenantId: string;
	productId: number;
}): Promise<Bundle> {
	const { data } = await axios.post(
		`${API_BASE_URL}/aibl-query/get-product-details`,
		{
			numericId: productId,
			tenantId,
		},
	);

	return data.data.productDetails;
}

export async function fetchProductMetadata({
	tenantId,
	productId,
	userId,
}: {
	tenantId: string;
	productId: string;
	userId: string;
}): Promise<BundleMetaData> {
	const { data } = await axios.post(
		`${API_BASE_URL}/aibl-query/get-product-metadata`,
		{
			productId,
			tenantId,
			userId,
		},
	);

	return data.data;
}
